import type { AutocompleteProps } from '@mui/material';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { isNotEmptyString, withDefault } from '@vy/utils';
import React from 'react';
import { useEventFieldValues } from '../../../../hooks/requests/use-event-field-values';

type MeterFieldValueSelectProps = Omit<
  AutocompleteProps<string, false, false, true>,
  'options' | 'renderInput'
> & {
  eventName: string | undefined;
  fieldName: string | undefined;
  label?: string;
  inputRef?: React.Ref<HTMLInputElement>;
};

export const MeterFieldValueSelect: React.FC<MeterFieldValueSelectProps> = ({
  eventName = '',
  fieldName = '',
  label = 'Field',
  inputRef,
  ...props
}) => {
  const eventFieldValuesEnabled = isNotEmptyString(eventName) && isNotEmptyString(fieldName);

  const { data, isLoading } = useEventFieldValues(eventName, fieldName, {
    enabled: eventFieldValuesEnabled,
  });

  const eventFieldValues = withDefault(data?.eventFieldValues, []);

  return (
    <Autocomplete
      size="small"
      {...props}
      options={eventFieldValues}
      loading={isLoading}
      freeSolo
      autoSelect
      renderInput={(params) => (
        <TextField
          label={label}
          placeholder="Select criterion"
          {...params}
          inputRef={inputRef}
          slotProps={{
            ...params.slotProps,

            htmlInput: {
              ...params.slotProps.htmlInput,
              autoComplete: 'new-password',
            },

            inputLabel: { shrink: true }
          }} />
      )}
    />
  );
};
